const GSM_BASIC_CHARACTERS = new Set((
  '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡' +
  'ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà'
).split(''))

const GSM_EXTENDED_CHARACTERS = new Set(['\f', '^', '{', '}', '\\', '[', '~', ']', '|', '€'])

export function containsCyrillic (text = '') {
  return text !== '' && !isGsm7Compatible(text)
}

export function isGsm7Compatible (text = '') {
  for (const ch of text) {
    if (!GSM_BASIC_CHARACTERS.has(ch) && !GSM_EXTENDED_CHARACTERS.has(ch)) {
      return false
    }
  }
  return true
}

export function analyzeSmsText (text = '') {
  if (!text) {
    return {
      encoding: 'GSM_7BIT',
      unitCount: 0,
      singlePartLimit: 160,
      multipartPartLimit: 153,
      maxLength: 612,
      parts: 0,
      isValid: true
    }
  }

  if (isGsm7Compatible(text)) {
    let septetLength = 0

    for (const ch of text) {
      septetLength += GSM_EXTENDED_CHARACTERS.has(ch) ? 2 : 1
    }

    const parts = septetLength <= 160
      ? 1
      : septetLength <= 612
        ? Math.ceil(septetLength / 153)
        : -1

    return {
      encoding: 'GSM_7BIT',
      unitCount: septetLength,
      singlePartLimit: 160,
      multipartPartLimit: 153,
      maxLength: 612,
      parts,
      isValid: parts >= 1 && parts <= 4
    }
  }

  const unicodeLength = text.length
  const parts = unicodeLength <= 70
    ? 1
    : unicodeLength <= 252
      ? Math.ceil(unicodeLength / 63)
      : -1

  return {
    encoding: 'UCS2',
    unitCount: unicodeLength,
    singlePartLimit: 70,
    multipartPartLimit: 63,
    maxLength: 252,
    parts,
    isValid: parts >= 1 && parts <= 4
  }
}

function trimLastVisibleSymbol (text) {
  return Array.from(text).slice(0, -1).join('')
}

export function trimTextToA1Limit (text = '', previousText = '') {
  const initialAnalysis = analyzeSmsText(text)
  if (initialAnalysis.isValid) {
    return text
  }

  // Special case:
  // If the previous text was GSM and the user appended non-GSM/UCS2 text at the end,
  // keep the newly appended suffix and trim the older GSM prefix instead.
  if (
    previousText &&
    text.startsWith(previousText) &&
    isGsm7Compatible(previousText) &&
    !isGsm7Compatible(text)
  ) {
    const appendedSuffix = text.slice(previousText.length)
    let base = previousText
    let result = base + appendedSuffix

    while (base) {
      const analysis = analyzeSmsText(result)
      if (analysis.isValid) {
        return result
      }

      base = trimLastVisibleSymbol(base)
      result = base + appendedSuffix
    }

    if (analyzeSmsText(result).isValid) {
      return result
    }
  }

  // Default behavior
  let result = text

  while (result) {
    const analysis = analyzeSmsText(result)
    if (analysis.isValid) {
      return result
    }
    result = trimLastVisibleSymbol(result)
  }

  return result
}

export function getTextareaMaxLength (text = '') {
  if (!text) {
    return 612
  }

  const trimmedText = trimTextToA1Limit(text)
  const analysis = analyzeSmsText(trimmedText)

  return trimmedText.length + Math.max(analysis.maxLength - analysis.unitCount, 0)
}